export default "__VITE_ASSET__$ya9xNc3__"